// @flow
import React from 'react';
import { FacetSearch } from 'Components/widgets/facet-search/FacetSearch.jsx';
import ReactAppContext from 'Context/ReactAppContext';
import { isFeatureFlipped } from 'Utils/feature-flipping/featureFlippingUtils';

type Props = {|
  id: string,
  config: CMSContent,
  offer: Offer,
|};

export function ProductsFiltersLine({ config, id, offer }: Props) {
  const appContext = React.useContext(ReactAppContext);

  if (!offer) {
    return null;
  }

  const isProductComparisonModeAuthorized = isFeatureFlipped(appContext)(
    'search.productComparison',
  );
  return (
    <div id={id} className="Line Line-ProductsFilters">
      <FacetSearch
        hideSearchInput
        i18n={config}
        initialIsSearchEnabled
        initialProducts={offer.products || []}
        isProductComparisonModeAuthorized={isProductComparisonModeAuthorized}
        offer={offer}
        resetSearchAtMount
        shouldPersistCriteriaInUrl
        withSearchFacets
        withSearchForm
        withSearchResults
      />
    </div>
  );
}
